module.exports = __webpack_public_path__ + "img/icon-pin.55250849.svg";